import { createAction } from '@mews/framework';
import { TimeUnit } from '@mews/enums';
import { getTimeUnitByServiceId } from '@mews-commander/legacy-entities/src/ducks';
import {
    hasDatesSelected,
    hasAnyReservation,
    getSelectedReservationPlaceId,
    getSelectedEntityTimeUnitServiceIds,
    getServiceId,
    getSelectedEntityEnterpriseIds,
} from '../selectors';
import { RESERVATION_PLACE_SELECTED, RESERVATION_PLACE_CHANGE_STARTED, TIMES_RESET } from './types';
import { selectService, serviceChangeReset } from './service';
import { fetchServicesCategories, processSelectedReservationPlace } from './availability';

export const selectReservationPlace =
    (selectedReservationPlaceId: $TSFixMe, scope: $TSFixMe) => async (dispatch: $TSFixMe, getState: $TSFixMe) => {
        const state = getState();
        const currentReservationPlaceId = getSelectedReservationPlaceId(state, { scope });

        if (selectedReservationPlaceId !== currentReservationPlaceId) {
            if (hasAnyReservation(getState(), { scope })) {
                return dispatch(createAction(RESERVATION_PLACE_CHANGE_STARTED, selectedReservationPlaceId, { scope }));
            }

            dispatch(createAction(RESERVATION_PLACE_SELECTED, selectedReservationPlaceId, { scope }));

            const enterpriseIds = getSelectedEntityEnterpriseIds(getState(), { scope });
            await dispatch(fetchServicesCategories(enterpriseIds));

            const selectedServiceId = getServiceId(state, { scope });
            const serviceIds = getSelectedEntityTimeUnitServiceIds(getState(), { scope });

            if (serviceIds.length === 1) {
                await dispatch(selectService(serviceIds[0], scope));
            } else if (selectedServiceId) {
                dispatch(serviceChangeReset(scope));
                const serviceTimeUnit = getTimeUnitByServiceId(state, { serviceId: selectedServiceId });
                if (serviceTimeUnit !== TimeUnit.Hour) {
                    dispatch(createAction(TIMES_RESET, {}, { scope }));
                }
            }

            if (hasDatesSelected(getState(), { scope })) {
                dispatch(processSelectedReservationPlace(scope));
            }
        }
    };
